import has from "lodash/has";
import remove from "lodash/remove";
import some from "lodash/some";
import isNull from "lodash/isNull";
import settings from "settings";
import { UPDATE_ACCOUNT_INFO } from "../Actions/ActionAccount";
import { INVITES_CHANGE_ORDER, INVITES_CHANGE_PAGE, INVITES_PROCESSING_FAILED, INVITES_PROCESSING_SUCCESS, INVITES_START_PROCESSING, INVITES_TOGGLE_FETCHING, INVITES_UPDATE_ERROR, INVITES_UPDATE_INVITES } from "../Actions/ActionInvites";

const initialState = {
  sort: {
    order: 'updated_at',
    isAsc: false
  },
  isFetching: false,
  page: 1,
  invites: [],
  battleTypeSelected: settings.defaultBattleType,
  meta: null,
  error: null,
  idsToProcess: [],
  missingStatistics: false
};

export const invites = (state = initialState, action) => {
  let invites = null;
  let idsToProcess = null;
  let meta = null;
  switch (action.type) {
    case UPDATE_ACCOUNT_INFO:
      if (has(action.info, 'clanId')) {
        return initialState;
      }

      return state;
    case INVITES_CHANGE_PAGE:
      return Object.assign({}, state, {
        page: action.page
      });
    case INVITES_CHANGE_ORDER:
      return Object.assign({}, state, {
        sort: {
          order: action.order,
          isAsc: action.isAsc
        }
      });
    case INVITES_TOGGLE_FETCHING:
      return Object.assign({}, state, {
        isFetching: !state.isFetching
      });
    case INVITES_UPDATE_INVITES:
      {
        const missingStatistics = some(action.data.invites, invite => {
          return isNull(invite.statistics.btl);
        });
        return Object.assign({}, state, {
          isFetching: false,
          invites: action.data.invites,
          meta: action.data._meta_,
          error: null,
          missingStatistics
        });
      }
    case INVITES_UPDATE_ERROR:
      return Object.assign({}, state, {
        isFetching: false,
        invites: [],
        meta: null,
        error: action.error
      });
    case INVITES_START_PROCESSING:
      return Object.assign({}, state, {
        idsToProcess: [...state.idsToProcess, action.id]
      });
    case INVITES_PROCESSING_SUCCESS:
      idsToProcess = [...state.idsToProcess];
      invites = [...state.invites];
      remove(idsToProcess, value => value === action.id);
      remove(invites, invite => invite.id === action.id);
      meta = Object.assign({}, state.meta);

      if (meta && meta.total > 0) {
        meta.total--;
      }

      return Object.assign({}, state, {
        invites,
        idsToProcess,
        meta
      });
    case INVITES_PROCESSING_FAILED:
      idsToProcess = [...state.idsToProcess];
      remove(idsToProcess, value => value === action.id);
      return Object.assign({}, state, {
        idsToProcess: idsToProcess
      });
    default:
      return state;

  }
};